<div class="div-arriere-plan-action" (click)="clicAction($event)"></div>
<div [ngClass]="isMobile ? 'div-global-action-mob' : ''" class="div-global-action" (click)="clicAction($event)">
  <div id="center-square" class="w-full">
    <div class="flex-row content-end">
      <div class="cross" (click)="cancelDetails(false)">
      </div>
    </div>

    <div class="text-center">
      <p class="dark-blue bold text-md no-margin text-center">VOUS QUITTEZ L’ESPACE DE TEST ET RETOURNEZ SUR LE SCRUTIN
        OFFICIEL POUR VOUS PERMETTRE DE DÉPOSER VOTRE BULLETIN DANS L'URNE.</p>
      <!-- <p class="dark-blue test-md text-center no-margin">Cet espace de vote réel vous permet de sélectionner vos choix définitifs.</p> -->
    </div>
    <img src="assets/test-icon.svg" alt="" class="mb-10 mt-10 margin-auto" width="63px">

    <div class="bg-light-blue p-20" style="border-radius: 10px;">
      <div class="flex-row align-items-center gap-10">
        <span class="exclamation light-blue bold">!</span>
        <p class="white text-md no-margin"><span class="bold">Attention </span>: 
          <!-- votre bulletin sera déposé dans l'urne et ne sera plus modifiable à postériori. -->
           Une fois déposé dans l'urne, votre bulletin ne pourra plus être modifié.
        </p>

      </div>
    </div>

    <p class="dark-blue text-md no-margin text-center pointer" (click)="cancelDetails(false)">Ok</p>
  </div>
</div>